import { render } from "./Saih.view.vue?vue&type=template&id=5c98037b&scoped=true&ts=true"
import script from "./Saih.view.vue?vue&type=script&lang=ts"
export * from "./Saih.view.vue?vue&type=script&lang=ts"

import "./Saih.view.vue?vue&type=style&index=0&id=5c98037b&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c98037b"]])

export default __exports__